import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";

const Error48HrDialog = ({
  open72HrPopup,
  handleClose,
  handle48HrErrorPrevious,
}) => {
  return (
    <Dialog
      // fullWidth={fullWidth}
      titleStyle={{ textAlign: "center" }}
      maxWidth="md"
      maxHeight={"sm"}
      open={open72HrPopup}
      onClose={handleClose}
      aria-labelledby="max-width-dialog-title2"
    >
      <div style={{ paddingLeft: "20px", paddingRight: "20px" }}>
        <div className="s20"></div>
        <DialogTitle id="max-width-dialog-title2">
          <Typography variant="h5" align="center">
            Confirm report information
          </Typography>
          <Typography
            style={{ marginTop: "10px", color: "#B00020" }}
            variant="h5"
            align="center"
          >
            Not enough data to generate the report
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Container
            style={{
              width: "700px",
              height: "400px",
            }}
          >
            <Grid
              container
              style={{
                paddingTop: "20px",
                paddingLeft: "15px",
                paddingRight: "15px",
              }}
            >
              <Grid item>
                <Typography style={{ color: "#B00020" }}>
                  The selected device does not have enough data to generate a
                  48-hour clearance test report.
                </Typography>
                <Typography style={{ marginBottom: "20px" }}>
                  We will send you a notification email when the report is ready
                  and you can continue generating the report now.
                </Typography>
                <Typography
                  style={{
                    color: "#B00020",
                    marginBottom: "20px",
                  }}
                >
                  Once a report is generated, it cannot be generated again, so
                  make sure the report information is updated and ready to
                  generate the report.
                </Typography>
                <Typography style={{ color: "#B00020", marginBottom: "20px" }}>
                  We offer only one 48-hour radon report per device at no cost.
                  To generate the 48-hour clearance test report, ensure that the
                  device has been activated and remains connected to a Wi-Fi
                  network for a minimum of 72 hours.
                </Typography>
                <Typography style={{ marginBottom: "20px" }}>
                  Make sure you enter all the information for your radon report.
                  <ul style={{ paddingLeft: "2em", marginTop: "5px" }}>
                    <li>Device information</li>
                    <li>Client information Location</li>
                    <li>information</li>
                  </ul>
                </Typography>
                <Typography>
                  If not, close this window. Go to your dashboard, select the
                  device you want to generate a report for, update all
                  information and try generating the report again
                </Typography>
              </Grid>
            </Grid>
          </Container>
        </DialogContent>
        <div className="s20"></div>
        <DialogActions>
          <Box
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "flex-start",
            }}
          >
            <Button
              style={{
                color: "#000000",
                width: "150px",
                height: "36px",
              }}
              onClick={handleClose}
            >
              <u>Cancel</u>
            </Button>
          </Box>
          <Box
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "flex-end",
            }}
          >
            <Button
              style={{
                background: "#E0E0E0",
                color: "#000000",
                width: "150px",
                height: "36px",
              }}
              onClick={handle48HrErrorPrevious}
              color="primary"
            >
              Previous
            </Button>
            <Box style={{ width: "10px" }} />
            <Button
              style={{
                background: "#3DB5E6",
                color: "#FFFFFF",
                width: "150px",
                height: "36px",
              }}
              onClick={handleClose}
              color="primary"
            >
              Close
            </Button>
          </Box>
        </DialogActions>
        <div className="s20"></div>
      </div>
    </Dialog>
  );
};

export default Error48HrDialog;
